import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConfigProvider } from "../../config-provider.service";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { CurrentUser } from "../../common/providers/current-user";
import { File } from "../../common/models/file";
import { map } from "rxjs/operators";
@Injectable({providedIn: 'root'})
export class FilesProvider {
    constructor(
        private _conf: ConfigProvider,
        private _utils: UtilsProvider,
        private api: ApiBaseService,
        private http: HttpClient,
        private currentUser: CurrentUser
    ) { }

    public downloadFile(api: string, file: File | null = null, range = false): Observable<any> {
        const downloadApi: string = file ? api + '/' + file.id : api;
          return this.api.call(                'get',
                downloadApi,
                { },
                {
                    accessToken: this.currentUser.getAccessToken(),
                    resultType: 'file'
                },
                false,
                range
            ).pipe(
                map((response: any) => {
                    return response;
                })
            );
    }

    public download(api: string, file: File | null = null): Observable<HttpEvent<any>> {
        const path: string = file ? api + '/' + file.id : api;

        const headers = new HttpHeaders()
            .set('Range', 'bytes=0-1023')
            .set('Authorization', 'Bearer ' + this.currentUser.getAccessToken());
        ;

        return this.api.specialCall(path, {
            observe: 'response',
            responseType: 'blob',
            reportProgress: false,
            headers
        });
    }
}
